import { Tab } from '@headlessui/react';
import { oneLine } from 'common-tags';

import { childrenToArray } from '@/lib/utils';

import type { FunctionComponent, ReactNode } from 'react';
import type { TypeTabHeaderProps } from './types';

export const TabHeader: FunctionComponent<TypeTabHeaderProps> = ({
  className = '',
  title,
  children,
}: TypeTabHeaderProps): JSX.Element => {
  const arrayOfChildren: ReactNode[] = childrenToArray(children);
  const list = arrayOfChildren.map((child: ReactNode, index: number) => (
    <Tab
      as="h2"
      key={index}
      className={({ selected }) => oneLine`
        u-actions u-actions--nav relative flex-shrink-0 cursor-pointer pb-1.5 first-of-type:pl-4 last-of-type:pr-4
        ${
          selected
            ? `after:absolute after:bottom-0 after:left-0 after:right-0 after:h-1 after:bg-[url("/assets/images/underline.svg")] after:bg-bottom after:bg-no-repeat after:content-['']`
            : ''
        }
      `}
    >
      {child}
    </Tab>
  ));

  return (
    <div className="relative before:absolute before:left-4 before:right-4 before:top-0 before:h-px before:border-t before:border-dashed before:border-primary-900 before:content-[''] after:absolute after:bottom-0 after:left-4 after:right-4 after:hidden after:h-px after:border-b after:border-dashed after:border-primary-900 after:content-[''] md:px-4 after:md:block">
      <div
        className={`relative -mx-4 flex items-center gap-16 px-4 py-2 md:overflow-x-auto md:px-0 min-[1160px]:mx-0 xl:gap-32 ${className}`}
      >
        <span className="u-headline u-headline@mobile--h2 hidden border-r border-primary-900 py-2 pl-4 pr-6 md:inline-block min-[1160px]:pl-0">
          {title}
        </span>
        <Tab.List className="flex items-center gap-10 overflow-x-scroll pb-2 pt-3 md:overflow-x-visible">
          {list}
        </Tab.List>
      </div>
    </div>
  );
};
